import { Box, Divider, DividerProps } from "@chakra-ui/react";
import React from "react";

export const ThinDivider: React.FC<DividerProps> = ({ ...props }) => (
  <Box>
    <Divider height="1px" width="100%" borderColor="#d9d9d9" {...props} />
  </Box>
);
